import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

const theme = {
    primary: "#023344",
    secondary: "#F7901E",
    tertiary: "#bbbbbb",
    quaternary: "#003c96",
    quinary: "#003c96",
    accent: "#0dbf66",
    error: "#c52e00"
};

export default new Vuetify({
    icons: {
        iconfont: "mdi",
    },
    theme: {
        dark: false,
        themes: {
            light: theme,
        },
    },
});
